export default __webpack_public_path__ + "static/media/Blooded Helm of the Plains.79d58591.jpg";